import { Badge, type BadgeProps } from '@shared/components';
import type { StatementStatus } from '../../utils/statementRows';

interface Props {
    status: StatementStatus;
}

const PILLS: Record<StatementStatus, { label: string; variant: NonNullable<BadgeProps['variant']> }> = {
    reconciled: { label: 'Reconciled', variant: 'success' },
    pending: { label: 'Pending', variant: 'warning' },
    scheduled: { label: 'Scheduled', variant: 'info' },
    overdue: { label: 'Overdue', variant: 'error' },
    held: { label: 'Held', variant: 'secondary' },
};

export function StatementStatusPill({ status }: Props) {
    const { label, variant } = PILLS[status];
    return <Badge variant={variant}>{label}</Badge>;
}
